import { React, PT } from '@gasbuddy/react';
import { List } from 'semantic-ui-react';
import { BrandLogo } from './BrandLogo';
import { DeleteButton } from './DeleteButton';

export const PoiBrand = ({ brands, deleter }) => {
  let brandItems = '';
  if (brands) {
    brandItems = brands.map((brand) => {
      const listItem = (
        <List.Item key={brand.branding_type}>
          <List.Content>
            <BrandLogo brand={brand} />
            {brand.branding_type}
            {deleter && (
              <DeleteButton
                tooltip={`Remove ${brand.branding_type} branding`}
                confirm={`Are you sure you want to delete the ${brand.branding_type} branding?`}
                deleter={() => deleter(brand.branding_type)}
              />
            )}
          </List.Content>
        </List.Item>
      );
      return listItem;
    });
  }
  return (
    <List>
      <List.Header>Brands</List.Header>
      {brandItems}
    </List>
  );
};

PoiBrand.defaultProps = {
  deleter: null,
};

PoiBrand.propTypes = {
  brands: PT.arrayOf(PT.shape({
    brand_id: PT.isnumber,
    brand_type: PT.string,
    image_url: PT.string,
  })).isRequired,
  deleter: PT.func,
};
